/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ActionReference, GameObjectReference, GameState } from "../../../shared/types";
import { LitElement, TemplateResult, css, html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { getState, performAction } from "../services/routeService";
import clickSound from "../../wwwroot/effects/click.mp3";
import menuclickSound from "../../wwwroot/effects/MenuSound.mp3";
import themeSound from "../../wwwroot/effects/Theme.mp3";


@customElement("game-canvas")
export class GameCanvas extends LitElement {
    [x: string]: any;
    public static styles = css`
    
    
    /* Layout Styles */
    .game {
        height: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto auto 1fr auto;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
    }
    
    .pause-menu {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(34, 32, 30, 0.8);
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    .pause-button {
        position: absolute;
        right: 0px;
        margin-right: -30px;
        margin-top: -20px;
        
   }

   
 
    .pause-button button {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
    }
 
    .header .pause-button img {
        width: 140px; 
        height: 80%;
    }

    
    .menu-content {
        background-color: #4a4a4a;
        width: 300px;
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    /* Button Styles */
    .menu-content button { 
        margin-bottom: 15px; 
        display: inline-block;
        user-select: none;
        padding: 10px 20px; 
        font-size: 20px;
        font-family: 'Roboto Mono', sans-serif;
        font-weight: 400;
        text-align: center;
        background-color: #2c3e50; 
        border: 1px solid #1f2a38; 
        color: #ffffff; 
        text-transform: uppercase;
        cursor: pointer;
        font-family: inherit; 
        font-size: inherit; 
        border-radius: 5px;
        box-shadow: 4px 4px black, 6px 7px white; 
        transition: transform 0.3s, box-shadow 0.3s; 
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    
    .menu-content button:last-child {
        margin-bottom: 0; 
    }
    
    /* Button Hover Effects */
    .menu-content button:hover {
        transform: translateY(1px); 
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5); 
    }
    .pause-button {
        position: absolute;
        right: 0px;
        margin-right: -30px;
        margin-top: -20px;
        
   }
    .pause-button button {
        background: none;
        border: none;
        cursor: pointer;
        padding: 0;
    }
 
    .header .pause-button img {
        width: 140px; 
        height: 80%;
    }

    .audio-buttons {
        display: flex;
    }
    
    .audio-buttons button {
        width: 60px; 
        height: 60px;
        margin-right: 10px;
    }
    
    .audio-buttons button img,
    .menu-buttons button img {
        width: 60px; 
        height: 60px;
    }
   
    
    /* Title Styles */
    .title {
        text-align: center;
        margin-top: 10px;
    }
   
    
    /* Header Styles */
    .header {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-grow: 1;
        z-index: 1; 
        position: relative;
        margin-bottom: -300px;
  
    }
   
   
    .header img {
        width: 75%;
        height: 60%;
        width: 75%;
        height: 60%;
        image-rendering: pixelated;
    }
   
   
    .header img:nth-child(n + 2) {
        position: absolute;
    }
   
   
    .content {
        flex-grow: 1;
        overflow: auto;
        margin-top: 10px;
        padding: 0 10px;
    }
   
   
    .content p {
        margin: 0 0 10px 0;
    }
   
   
    .content p:last-of-type {
        margin: 0;
    }
    
    .dark-mode .footer {
        border-radius: 10px 10px 0 0;
        background-color: #000000;
        border: 1px solid #333333;
        margin-top: 10px;
        display: flex;
        overflow-y: auto;
    }
  
   
   
    .footer {
        border-radius: 10px 10px 0 0;
        background-color: #444444; 
        border: 1px solid #333333; 
        margin-top: 10px;
        z-index: 2;
        padding-top: 10px;
        display: flex;
        overflow-y: auto; 
    }
    
    .footer .button {
        display: inline-block;
        vertical-align: middle;
        user-select: none;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        background: white;
        color: black;
        font-size: 20px;
        font-family: 'Roboto Mono', sans-serif;
        font-weight: 400;
        text-align: left;
        border: 3px solid black!important;
        border-radius: 0;
        box-shadow: 4px 4px black, 6px 7px white;
        padding-right: 5%;
        margin-top: 20px;
    }
   
   
    .footer .button {
        background-color: #2c3e50; 
        border: 1px solid #1f2a38; 
        color: #ffffff; 
        padding: 5px 10px;
        margin: 0 0 10px 10px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
        font-family: inherit;
        font-size: inherit;
        transition: background-color 0.3s ease;
        font-family: inherit;
        font-size: inherit;
        transition: background-color 0.3s ease;
        font-family: inherit;
        font-size: inherit;
        transition: background-color 0.3s ease;
    }
   
   
    .footer .button.active,
    .footer .button:hover {
        background-color: #1f2a38;
       
    }
    
    /* Button Container */
    .button-container {
        position: absolute;
        top: 0;
        right: 0;
    }
    
    /* Inventory Button */
    .inventory-button {
        margin-top: 80px;
        margin-right: -50px;
    }
    
    .inventory-button button {
            background: none;
            border: none;
            cursor: pointer;
            padding: 0;
    }
    
    .inventory-button img {
        width: 180px; 
        height: 80%; 
    }
    
    /* Inventory Popup */
    .inventory-popup {
        position: fixed;
        top: 250px; 
        right: 380px;
        background-color:  #2c3e50;
        border: 1px solid #000000;
        padding: 10px;
        border-radius: 5px;
        z-index: 999;
        color: white;
    }
    
    .inventory-popup button {
        margin-top: 10px;
        display: inline-block;
        vertical-align: middle;
        user-select: none;
        padding: 10px 20px;
        font-size: 20px;
        font-family: 'Roboto Mono', sans-serif;
        font-weight: 400;
        text-align: center;
        background-color: #2c3e50; 
        border: 1px solid #1f2a38; 
        color: #ffffff; 
        text-transform: uppercase;
        cursor: pointer;
        font-family: inherit;
        font-size: inherit;
        border-radius: 5px;
        box-shadow: 4px 4px black, 6px 7px white;
        transition: transform 0.3s, box-shadow 0.3s;
    }
    
    .inventory-popup button:hover {
        transform: translateY(1px);
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
    }
    
    .inventory-popup button.active {
        background-color: #1f2a38;
    }
    
    /* Header Ending */
    .header-ending {
        height: 100vh; 
        width: 100vw; 
        position: fixed; 
        top: 0; 
        left: 0;
    }
    
    /* Keyframes */
    @keyframes credits {
        0% {
            top: 100%;
        }
        100% {
            top: -500%;
        }
    }


.save-button {
    /* Your custom styles for the save button */
    background-color: #2c3e50; /* Dark blue background */
    border: 1px solid #1f2a38; /* Darker blue border */
    color: #ffffff; /* White text color */
    font-size: 16px; /* Adjust font size as needed */
    font-family: 'Marker Felt', fantasy; /* Marker Felt font with fantasy genre fallback */
    cursor: pointer; /* Show pointer cursor on hover */
    transition: background-color 0.3s ease; /* Smooth transition animation */
    margin-top: 10px; /* Adjust margin as needed */
    margin-left: 210px;
    margin-bottom: 20px;
    width: 600px; /* Adjust width as needed */
    height: 40px; /* Adjust height as needed */
}

.save-button:hover {
    background-color: #1f2a38; /* Darker blue color on hover */
}

    
`;

    private volumeControl?: HTMLInputElement;
    //Sound Elements
    private clickAudio: HTMLAudioElement = new Audio(clickSound);
    private MenuAudio = new Audio(menuclickSound);
    private gameThemeAudio = new Audio(themeSound);



    private playClickSound(): void {
        if (!this.isMuted) {
            this.clickAudio.currentTime = 0;
            void this.clickAudio.play();
        }
    }
    private playMenuSound(): void {
        if (!this.isMuted) {
            this.MenuAudio.currentTime = 0;
            void this.MenuAudio.play();
        }
    }
    private playGameTheme(): void {
        if (!this.isMuted && !this.isMusicOff) {
            this.gameThemeAudio.currentTime = 0;
            this.gameThemeAudio.loop = true;

        }
    }
    private isMenuVisible: boolean = false;
    private isMuted: boolean = false;
    private isMusicOff: boolean = false;
    private roomTitle?: string;
    private roomImages?: string[];
    private contentText?: string[];
    private actionButtons?: ActionReference[];
    private gameObjectButtons?: GameObjectReference[];
    private inventoryVisible: boolean = false;
    private inventoryItems: string[] = [];
    protected codeVault: string = "";
    protected magicWord: string = "";
    private selectedActionButton?: ActionReference;
    private selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();






    public connectedCallback(): void {
        super.connectedCallback();

        const darkModeEnabled: string | null = localStorage.getItem("darkModeEnabled");
        if (darkModeEnabled) {
            this.darkModeEnabled = JSON.parse(darkModeEnabled);
            document.body.classList.toggle("dark-mode", this.darkModeEnabled);
        }
        this.loadSettings();
        void this.refreshState();
    }

    private async refreshState(): Promise<void> {
        const state: GameState = await getState();

        this.updateState(state);
    }

    private updateState(state: GameState): void {
     
        this.roomAlias = state.roomAlias;
        this.roomTitle = state.roomTitle;
        this.roomImages = state.roomImages;
        this.contentText = state.text;

        this.actionButtons = state.actions;
        this.gameObjectButtons = state.objects;
        this.inventoryVisible = false;

        this.selectedActionButton = undefined;
        this.selectedGameObjectButtons.clear();
        this.inventoryItems = state.inventory || [];
        this.codeVault = state.codeVault ?? "";
        this.magicWord = state.magicWord ?? "";
      

        this.requestUpdate();
        this.playGameTheme();
    }

    private async handleClickAction(button: ActionReference): Promise<void> {
        this.playClickSound();
        if (button.needsObject) {
            this.selectedActionButton = button;
            this.selectedGameObjectButtons.clear();

            this.requestUpdate();
        } else {
            if (button.alias === "start-game") {

                this.playGameTheme();
            }

            const state: any = await performAction(button.alias);

            if (state === undefined) {
                return;
            }

            this.updateState(state);
        }
    }

    private async handleClickObject(button: GameObjectReference): Promise<void> {

        if (!this.selectedActionButton) {
            return;
        }

        this.selectedGameObjectButtons.add(button);

        const state: GameState | undefined = await performAction(
            this.selectedActionButton.alias,
            [...this.selectedGameObjectButtons].map((e) => e.alias)
        );

        if (this.selectedGameObjectButtons.size >= 2) {
            this.selectedActionButton = undefined;
            this.selectedGameObjectButtons.clear();
        }


        this.requestUpdate();

        if (state === undefined) {
            return;
        }

        this.updateState(state);
    }

    protected render(): TemplateResult {
        return html`
        <div class="game">
            ${this.renderTitle()}
            ${this.renderHeader()}
            ${this.renderContent()}
            ${this.renderMagicText()}
            ${this.renderVaultInputCode()} 
            ${this.renderFooter()}
            ${this.renderPauseMenu()}
        </div>
    `;
    }

    private renderTitle(): TemplateResult {
        if (this.roomTitle === "EndGameRoom") {
            return html``;
        } else {
            if (this.roomTitle) {
                return html`<div class="title">${this.roomTitle}</div>`;
            }
        }
        return html`${nothing}`;
    }

    private handleScreenClick(): void {
        if (this.roomTitle === "EndGameRoom") {
            localStorage.clear();
            window.location.reload();
        }
    }

    private renderHeader(): TemplateResult {
        if (this.roomImages && this.roomImages.length > 0) {
            if (this.roomTitle === "EndGameRoom") {
                // Setting overflow to "hidden" for the body element
                // This should ideally be done outside of this function
                document.body.style.overflow = "hidden";

                // Render header for end game room
                return html`
                <div class="header-ending" @click=${this.handleScreenClick}>
                    ${this.roomImages?.map((url) => html`<img class="fade-in" src="/assets/img/rooms/${url}.png" style="height: 100%; width: 100%; object-fit: cover;"/>`)}
                </div>
                <div class='wrapper'>
                    <div class='movie'>Thank you for playing ESCAPE</div>
                    <div class='movie'>This game was made by:</div>
                    <div class='name'>Elise Kooijman</div>
                    <div class='name'>Pierre Mokanda</div>
                    <div class='name'>Sem Wolff</div>
                    <div class='name'>Majd Hammid</div>
                    <div class='name'>Arif Şahin</div>
                    <div class='movie'>ALSO KNOWN AS</div>
                </div>
            `;
            } else {
                // Render header for other rooms
                return html`
                <div class="header">
                    ${this.roomImages?.map((url) => html`<img src="/assets/img/rooms/${url}.png" />`)}
                    <div class="button-container">
                        ${!this.hasStartGameAction() ? html`
                            <div class="pause-button">
                                <button @click=${this.handlePause}>
                                    <img src="/assets/img/rooms/SettingsIcon.png" alt="Pause">
                                </button>
                            </div>
                            <div class="inventory-button">
                                <button @click=${this.toggleInventory}>
                                    <img src="/assets/img/rooms/Inventory.png" alt="Inventory">
                                </button>
                            </div>` : ""}
                    </div>
                    ${this.renderInventoryPopup()} <!-- Render inventory popup -->
                </div>
            `;
            }
        }
        return html``; // Ensure there is a return statement at the end
    }

    private handlePause(): void {
        this.playMenuSound();
        this.isMenuVisible = !this.isMenuVisible;
        this.requestUpdate();
    }
    private renderPauseMenu(): TemplateResult {
        if (this.hasStartGameAction()) {
            return html``;
        }
        if (this.isMenuVisible) {
            return html`
                <div class="pause-menu">
                    <div class="menu-content">
                        <div class="audio-buttons">
                            <button @click=${this.toggleMute} class="${this.isMuted ? "muted" : ""}">
                                ${this.isMuted ? html`<img src="/assets/img/rooms/mutedIcon.png" alt="Muted">` : html`<img src="/assets/img/rooms/speaker.png" alt="Speaker">`}
                            </button>
                            <button @click=${this.toggleMusic} class="${this.isMusicOff ? "music-off" : ""}">
                                ${this.isMusicOff ? html`<img src="/assets/img/rooms/musicMute.png" alt="Music Off">` : html`<img src="/assets/img/rooms/musicIcon.png" alt="Music On">`}
                            </button>
                        </div>
                        <!-- Volume Adjustment Bar -->
                    <div class="volume-control">
                        <input type="range" min="0" max="100" .value=${this.volumeLevel}  @input=${this.adjustVolume}>
                    </div>
                        <div class="menu-buttons">
                            <button @click=${this.resumeGame}>Resume Game</button>
                            <button @click=${this.toggleDarkMode} class="dark-mode-button">
                        ${this.darkModeEnabled ? "Light Mode On" : "Light Mode Off"}
                    </button>
                             <button @click=${this.toggleLanguage}>Text to dutch</button>
                            <button @click=${this.resetGame}>Reset Game</button>
                            <button @click=${this.quitGame}>Quit Game</button>
                            
                        </div>
                    </div>
                </div>
            `;
        }
        return html``;
    }
    private volumeLevel: number = 100;
    private darkModeEnabled: boolean = false;
 
private toggleDarkMode(): void {
    this.darkModeEnabled = !this.darkModeEnabled;
    // Toggle dark mode class on body element
    document.body.classList.toggle("dark-mode", this.darkModeEnabled);
 
    
    const menuContent: HTMLElement | null = this.shadowRoot?.querySelector(".menu-content") || null;
    if (menuContent) {
        menuContent.style.backgroundColor = this.darkModeEnabled ? "#eeeeee" : "#4a4a4a";
    }
 
    const footer: HTMLElement | null = this.shadowRoot?.querySelector(".footer") || null;
    if (footer) {
        footer.style.backgroundColor = this.darkModeEnabled ? "#4a4a4a" : "#4a4a4a";
    }
}
 

    private renderInventoryPopup(): TemplateResult {
        if (this.inventoryVisible) {
            // Check if the inventory is empty
            if (this.inventoryItems.length === 0) {
                // Render a message indicating that the inventory is empty
                return html`<div class="inventory-popup">No item in <br>the inventory.</div>`;
            } else {
                // Render the popup with the inventory items
                return html`
                    <div class="inventory-popup">
                        <div class="inventory-content">
                            <h2 style="margin-top: -10px;">Inventory</h2>
                            <ul>
                                <!-- Iterate through each item in the inventory and render it as a list item -->
                                ${this.inventoryItems.map(item => html`<li>${item}</li>`)}
                            </ul>
                        </div>
                    </div> 
                `;
            }
        }
        return html``; // If inventory is not visible, render nothing
    }

    private adjustVolume(event: InputEvent): void {
        const volumeControl: HTMLInputElement = event.target as HTMLInputElement;
        const volumeLevel: number = parseInt(volumeControl.value);

        this.volumeLevel = volumeLevel;
        localStorage.setItem("volume", volumeLevel.toString());

        // Adjust the volume of all audio elements
        this.clickAudio.volume = volumeLevel / 100;
        this.MenuAudio.volume = volumeLevel / 100;
        this.gameThemeAudio.volume = volumeLevel / 100;
    }

    private toggleInventory(): void {
        this.inventoryVisible = !this.inventoryVisible; // Toggle inventory visibility
        this.requestUpdate(); // Trigger re-rendering of the component
    }

    private hasStartGameAction(): boolean {
        return !!this.actionButtons?.find(action => action.alias === "start-game");
    }

    private async resetGame(): Promise<void> {
        this.playClickSound();

        const confirmReset: boolean = window.confirm("Are you sure you want to start over?");
        if (!confirmReset) {
            return;
        }
        // Stop the game theme audio
        this.gameThemeAudio.pause();

        // Clear mute, music, and volume settings from local storage
        localStorage.removeItem("isMuted");
        localStorage.removeItem("isMusicOff");
        localStorage.removeItem("volume");
        localStorage.removeItem("darkModeEnabled");
        localStorage.removeItem("playerSessionId");

        // Reset the component's state variables to their default values
        this.isMuted = false;
        this.isMusicOff = false;

        // Set the volume level to 100
        this.volumeLevel = 100;

        // Perform the reset game action
        const state: GameState | undefined = await performAction("Reset-Game");
        if (state === undefined) {
            return;
        }

        // Update the component's state
        this.isMenuVisible = false;
        this.updateState(state);


        // Refresh the state immediately after resetting the game
        await this.refreshState();
    }

    private quitGame(): void {
        this.playClickSound();
        const confirmQuit: boolean = window.confirm("Are you sure you want to quit the game?");

        if (confirmQuit) {
            window.close();
        }
    }

    private toggleMute(): void {
        this.isMuted = !this.isMuted;
        localStorage.setItem("isMuted", JSON.stringify(this.isMuted));

        // Pause or resume all audio elements based on the isMuted flag
        if (this.isMuted) {
            // Play click sound only when muting
            this.playClickSound();
            this.clickAudio.pause();
            this.MenuAudio.pause();
            this.gameThemeAudio.pause();
        } else {
            // Resume click sound only when unmuting
            void this.clickAudio.play();
            // Resume other sounds only if music is not turned off
            if (!this.isMusicOff) {
                this.playGameTheme();
            }
        }

        this.requestUpdate();
    }

    private toggleMusic(): void {
        this.playClickSound();
        this.isMusicOff = !this.isMusicOff;
        localStorage.setItem("isMusicOff", JSON.stringify(this.isMusicOff));

        // Pause or resume the game theme audio based on the isMusicOff flag
        if (this.isMusicOff) {
            this.gameThemeAudio.pause();
        } else {
            // Play the game theme audio only if not muted
            if (!this.isMuted) {
                this.playGameTheme();
            }
        }

        this.requestUpdate();
    }
    private loadSettings(): void {
        const savedVolume: string | null = localStorage.getItem("volume");

        // Parse the saved volume as a float, or use the default value 100 if no volume is saved
        const volumeLevel: number = savedVolume ? parseFloat(savedVolume) : 100;

        // Set the volume level for all audio elements
        this.clickAudio.volume = volumeLevel / 100;
        this.MenuAudio.volume = volumeLevel / 100;
        this.gameThemeAudio.volume = volumeLevel / 100;

        // Set the volume bar value
        if (this.volumeControl) {
            this.volumeControl.value = volumeLevel.toString();
        }

        const savedIsMuted: string | null = localStorage.getItem("isMuted");
        if (savedIsMuted !== null) {
            this.isMuted = JSON.parse(savedIsMuted);
        }

        const savedIsMusicOff: string | null = localStorage.getItem("isMusicOff");
        if (savedIsMusicOff !== null) {
            this.isMusicOff = JSON.parse(savedIsMusicOff);
        }
        if (!this.isMusicOff && !this.isMuted) {
            this.playGameTheme();
        }

    }

    private resumeGame(): void {
        this.playClickSound();
        this.isMenuVisible = false;
        this.requestUpdate();
    }

    private async translateTextToDutch(text: string): Promise<string> {
        const apiKey: any = "AIzaSyBNt3AEUCkYAvZC7fFlYHNdhMcr_s6F5x8";
        const targetLanguage: any = "nl"; // Dutch language code

        const response: Response = await fetch(`https://translation.googleapis.com/language/translate/v2?key=${apiKey}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                q: text,
                target: targetLanguage,
            }),
        });

        const data: any = await response.json();
        if (data && data.data && data.data.translations && data.data.translations.length > 0) {
            return data.data.translations[0].translatedText;
        } else {
            console.error("Translation failed");
            return text; // Return original text in case of failure
        }
    }

    private async toggleLanguage(): Promise<void> {
        // Translate each text content to Dutch
        if (this.contentText && this.contentText.length > 0) {
            for (let i: any = 0; i < this.contentText.length; i++) {
                this.contentText[i] = await this.translateTextToDutch(this.contentText[i]);
            }
        }

        // Refresh the UI to display the translated text
        this.requestUpdate();
    }


    private renderContent(): TemplateResult {
        const contentDiv: HTMLElement = document.createElement("div");
        contentDiv.classList.add("content");

        this.contentText?.forEach((text, index) => {
            const paragraph: HTMLElement = document.createElement("p");
            paragraph.textContent = text;
            paragraph.style.opacity = "0"; // Initially set opacity to 0
            paragraph.style.transition = `opacity ${(index + 1) * 0.5}s`; // Add transition effect

            // Use setTimeout to trigger opacity change after a delay
            setTimeout(() => {
                paragraph.style.opacity = "1";
            }, (index + 1) * 500); // Delay in milliseconds

            contentDiv.appendChild(paragraph);
        });

        // Wrap the dynamically created contentDiv with the html template literal
        return html`${contentDiv}`;
    }


    private renderFooter(): TemplateResult {
        if (this.roomTitle === "EndGameRoom") {
            return html``;
        } else if (this.roomTitle === "Welcome") {
            return html`
            <style>
            .start-screen {
                z-index: 9999;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 30vh; /* Full viewport height */
                background-color: #000000;
                color: black; /* Changed text color to match button color */
                
            }
        
            .button {
                z-index: 9999;
                background-color: #000000;
                color: #03e9f4;
                font-weight: bold;
                border: none;
                border-radius: 5px;
                letter-spacing: 4px;
                overflow: hidden;
                transition: background-color 0.5s ease-in-out, color 0.5s ease-in-out, box-shadow 0.5s ease-in-out;
                cursor: pointer;
                padding: 15px 20px; /* Adjust padding as needed */
            }
            
        
            /* Adjusted selector to target <a> elements */
            .button:hover {
                background: #d6f5f4;
                color: #050801;
                box-shadow: 0 0 5px #03e9f4,
                    0 0 25px #03e9f4,
                    0 0 50px #03e9f4,
                    0 0 200px #03e9f4;
                    -webkit-box-reflect: below 1px linear-gradient(transparent, #0005);
            }
        </style>
                <div class="start-screen">
                    <div>
                        ${this.actionButtons?.map(
                (button) => html`
                            <a
                                class="button ${this.selectedActionButton === button ? "active" : ""}"
                                @click=${(): void => void this.handleClickAction(button)}
                                >${button.label}
                            </a>`
            )}
                    </div>
                </div>
            `;
        } else {
            return html`
                <div class="footer">
                    <div class="buttons">
                        <div>
                            ${this.actionButtons?.map(
                (button) => html`<a
                                    class="button ${this.selectedActionButton === button ? "active" : ""}"
                                    @click=${(): void => void this.handleClickAction(button)}
                                    >${button.label}</a>`
            )}
                        </div>
                        <div>
                            ${this.selectedActionButton
                    ? this.gameObjectButtons?.map(
                        (button) => html`<a
                                        class="button ${this.selectedGameObjectButtons.has(button) ? "active" : ""}"
                                        @click=${(): void => void this.handleClickObject(button)}
                                        >${button.name}</a>`
                    )
                    : nothing}
                        </div>
                    </div>
                </div>
            `;
        }
    }












    private renderMagicText(): TemplateResult {
        if (!this.contentText || this.contentText.length === 0) {
            return html``;
        }
        const isUnlockMessagePresent: boolean = this.contentText.includes("What word will you write down?");
        if (isUnlockMessagePresent) {
            return html`
        <style>
        .background {
            position: relative;
            font-family: 'AgendaKind';
            top: 10px;
            background: url("https://i.imgur.com/0kjMcUe.png");
            background-size: cover;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            width: 60%;
            height: 15vh;
            padding: 30px 80px 50px 80px;
            z-index: 1;
            filter: brightness(0.95) sepia(30%) saturate(80%);
            border-radius: 30px;
            clip-path: polygon(
                0% 0%,
                0% 93%,
                5% 98%,
                6% 99%,
                8% 95%,
                12% 94%,
                15% 97%,
                17% 93%,
                20% 98%,
                22% 97%,
                25% 99%,
                31% 94%,
                35% 93%,
                39% 96%,
                43% 93%,
                45% 94%,
                47% 95%,
                50% 92%,
                52% 96%,
                54% 93%,
                58% 92%,
                60% 95%,
                62% 93%,
                65% 96%,
                69% 93%,
                72% 93%,
                75% 94%,
                79% 97%,
                81% 94%,
                85% 93%,
                88% 92%,
                90% 95%,
                93% 93%,
                95% 92%,
                97% 95%,
                100% 97%,
                100% 0%
            );
            overflow: hidden;
        }
    
        .background input[type="text"] {
            width: 100%;
            padding: 15px; /* Increased padding */
            border: none;
            border-bottom: 2px solid #8b4513;
            font-family: 'AgendaKind';
            font-size: 20px; /* Increased font size */
            font-weight: bold; /* Added font weight */
            color: #ff0000; /* Set text color to red */
            background-color: transparent;
            margin-bottom: 20px;
        }
    
        .background input[type="text"]::placeholder {
            color: #ff0000; /* Set placeholder text color to red */
        }
    
        .background input[type="text"]:focus {
            outline: none;
            border-color: transparent; /* Hide border on focus */
            border-bottom: 2px solid #8b4513; /* Show brown line at the bottom on focus */
        }
    
        .background input[type="text"]:focus + .magicsave-button {
            border-color: transparent; /* Hide button border on focus */
        }
    
        .background input[type="text"]:focus + .magicsave-button:hover {
            background-color: #8b4513; /* Keep button color on focus */
        }
    
        .magicsave-button {
            background-color: #8b4513;
            color: white;
            border: none;
            border-radius: 5px;
            padding: 10px; /* Adjusted padding */
            font-family: 'AgendaKind';
            font-size: 20px; /* Adjusted font size */
            cursor: pointer;
            transition: background-color 0.3s ease;
        }
        
        .magicsave-button:hover {
            background-color: #592c19;
        }
    
        .magic-input-container {
            position: relative;
            margin-bottom: 20px;
            font-family: 'AgendaKind';
        }
    
        .magic-input-container label {
            font-family: 'AgendaKind';
            font-size: 20px;
            color: #592c19;
            display: block;
            margin-bottom: 5px;
        }
    </style>
    
    <div class="background">
    <div class="magic-input-container">
        <label for="magic-code">Write the magic word:</label>
        <input type="text" id="magic-code" name="magic-code" placeholder="">
        <button class="magicsave-button" @click=${this.saveMagicWord}>Word Written</button>
    </div>
</div>
`;
        } else {
            return html`
        `;
        }
    }

    private async saveMagicWord() {
        const inputElement: HTMLInputElement | null = this.shadowRoot?.querySelector("#magic-code") as HTMLInputElement | null;
        if (!inputElement) {
            return;
        }
        const writtenWord: string = inputElement.value.trim();
        inputElement.value = "";

        const state: any = await performAction("interact", ["enchanted-quill"], [], "", writtenWord);
        this.updateState(state);
        console.log(state);
    }


    private renderVaultInputCode(): TemplateResult {
        if (!this.contentText || this.contentText.length === 0) {
            return html``;
        }
        const isUnlockMessagePresent: boolean = this.contentText.includes("What code should I enter?");
        if (isUnlockMessagePresent) {
            return html`
            <style>
            
            .vault-input-container {
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
                padding: 20px;
                border: 2px solid #555;
                border-radius: 10px;
                display: inline-block;
                z-index: 100000; 
            }
            
            .vault-input-container label {
                color: #FFF;
                font-weight: bold;
                margin-bottom: 10px;
                display: block;
            }
            
            .vault-input-container input {
                padding: 10px;
                width: 100px;
                border: 2px solid #555;
                border-radius: 5px;
                background-color: #333;
                color: #FFF;
                text-align: center;
                font-family: Onesize;
                box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
                outline: none;
            }
            
            .vault-input-container input::placeholder {
                color: #888;
            }
            
            .remove-button {
                background-color: #555; /* Dark metallic color */
                border: none;
                color: white;
                padding: 10px 20px; /* Adjust padding as needed */
                text-align: center;
                text-decoration: none;
                display: inline-block;
                font-size: 16px;
                border-radius: 5px;
                cursor: pointer;
                margin-right: 10px; /* Add space between number buttons and remove button */
                transition: background-color 0.3s; /* Smooth transition on hover */
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Add shadow for depth */
            }
            
            .remove-button:hover {
                background-color: #777; /* Darker color on hover */
            }
            
            .remove-button:active {
                background-color: #333; /* Darker color on click */
                transform: translateY(2px); /* Add slight downward movement on click */
                box-shadow: none; /* Remove shadow on click */
            }

            .buttonvault-container {
                margin-top: 10px;
                z-index: 9999; /* Set a higher z-index */
            }
            
            .number-button {
                background-color: #555;
                border: none;
                color: white;
                padding: 10px;
                text-align: center;
                text-decoration: none;
                display: inline-block;
                font-size: 16px;
                border-radius: 5px;
                cursor: pointer;
                margin-right: 5px;
                z-index: 9999; /* Set a higher z-index */
            }
            
            .number-button:hover {
                background-color: #777;
            }

            .submit-button {
                background-color: #555; /* Dark metallic color */
                border: none;
                color: white;
                padding: 15px 32px;
                text-align: center;
                text-decoration: none;
                display: inline-block;
                font-size: 16px;
                border-radius: 5px;
                cursor: pointer;
                margin-top: 20px; /* Adjust as needed */
                transition: background-color 0.3s; /* Smooth transition on hover */
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Add shadow for depth */
            }
            
            .submit-button:hover {
                background-color: #777; /* Darker color on hover */
            }
            
            .submit-button:active {
                background-color: #333; /* Darker color on click */
                transform: translateY(2px); /* Add slight downward movement on click */
                box-shadow: none; /* Remove shadow on click */
            }

            .save-button {
                background-color: #555; /* Dark metallic color */
                border: none;
                color: white;
                padding: 10px 20px; /* Adjust padding as needed */
                text-align: center;
                text-decoration: none;
                display: inline-block;
                font-size: 16px;
                border-radius: 5px;
                cursor: pointer;
                margin-right: 5px; /* Add margin to separate from number buttons */
                transition: background-color 0.3s; /* Smooth transition on hover */
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3); /* Add shadow for depth */
            }
            
            .save-button:hover {
                background-color: #777; /* Darker color on hover */
            }
            
            .save-button:active {
                background-color: #333; /* Darker color on click */
                transform: translateY(2px); /* Add slight downward movement on click */
                box-shadow: none; /* Remove shadow on click */
            }
            
        </style>


        <div class="vault-input-container">
        <label for="vault-code">Enter Vault Code:</label>
        <input type="text" id="vault-code" name="vault-code" maxlength="3" pattern="[0-9]*" placeholder="000">
        <button class="remove-button" @click=${this.removeLastNumber}>Remove</button>
        <div class="buttonvault-container">
            ${Array.from({ length: 10 }, (_, i) => html`<button class="number-button" @click=${() => this.insertNumber(i)}>${i}</button>`)}
            <button class="save-button" @click=${this.handleSetVaultCode}>Save Code</button>
        </div>
    </div>
    `;
        } else {
            return html``;
        }
    }

    private insertNumber(number: number) {
        const inputElement: HTMLInputElement | null = this.shadowRoot?.querySelector("#vault-code") as HTMLInputElement | null;
        if (inputElement && inputElement.value.length < 3) {
            inputElement.value += number.toString();
        }
    }

    private removeLastNumber(): void {
        const inputElement: HTMLInputElement | null = this.shadowRoot?.getElementById("vault-code") as HTMLInputElement | null;
        if (inputElement) {
            inputElement.value = inputElement.value.slice(0, -1);
        }
    }

    private async handleSetVaultCode() {
        const inputElement: HTMLInputElement | null = this.shadowRoot?.querySelector("#vault-code") as HTMLInputElement | null;
        if (!inputElement) {
            return;
        }

        const enteredCode: string = inputElement.value.trim();
        inputElement.value = "";

        const state: any = await performAction("interact", ["Vault"], [], enteredCode);
        this.updateState(state);
        console.log(state);
    }
};